export class iNotify {
    public NotificacionId: number;
    constructor() {
        this.NotificacionId = -1;
    }
}